import aidpAuthMiddleware from "./aidpAuthMiddleware";
import darkAuthMiddleware from "./darkAuthMiddleware";
import lightAuthMiddleware from "./lightAuthMiddleware";

const middleware = process.env.REACT_APP_IS_DARK === 'true' ? (process.env.REACT_APP_IS_AIDP === 'true' ? aidpAuthMiddleware : darkAuthMiddleware): lightAuthMiddleware;
export default middleware;